import * as React from 'react';

// tslint:disable:max-line-length
export const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.192 5.567L2.318.693a1.147 1.147 0 0 0-1.626 0 1.147 1.147 0 0 0 .001 1.625l4.874 4.874-4.874 4.875a1.147 1.147 0 0 0 0 1.625 1.147 1.147 0 0 0 1.625 0l4.874-4.875 4.875 4.875c.452.452 1.177.45 1.625 0a1.147 1.147 0 0 0 0-1.625L8.817 7.192l4.875-4.874a1.147 1.147 0 0 0 0-1.626 1.147 1.147 0 0 0-1.625.001L7.192 5.567z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);
